export default __webpack_public_path__ + "static/media/3_Tribunal_Check_Icon.c18a0f0a.svg";